import { convertRemToPx } from '@hivebrite/design-system/Theme';

import { getLastFrameAttributes } from 'hb-builder/components/BuilderComponents/page/block/Strips/utils/getLastFrameAttributes';
import { createNewItem } from 'hb-builder/utils/createNewItem';
import {
  BUTTON_MODE_OPTIONS,
  BUTTON_VARIANT_OPTIONS,
} from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';

export const getStripItemChildren = (props) => {
  const {
    components,
    featureFlags,
    features,
    stripsItem,
    theme,
    ...otherProps
  } = props;

  const { Button, Text } = components;

  const {
    headlineAttributesToApply,
    sublineAttributesToApply,
    buttonAttributesToApply,
  } = getLastFrameAttributes(stripsItem);

  const headline = Text.item({
    ...props,
    features: {
      ...features,
      text: {
        ...features?.text,
        containerPadding: 0,
        content: __('Headline'),
        defaultTextColor: true,
        horizontalAlign: 'left',
        lineHeight: theme
          ? convertRemToPx(parseFloat(theme.fontSizes[7])) * 1.5
          : undefined,
        textColor: '#000',
        textFontSize: theme
          ? convertRemToPx(parseFloat(theme.fontSizes[7]))
          : undefined,
        tied: true,
      },
    },
  });

  const subline = Text.item({
    ...props,
    features: {
      ...features,
      text: {
        ...features?.text,
        containerPadding: 0,
        content: __('Subtitle goes here'),
        defaultTextColor: true,
        horizontalAlign: 'left',
        textColor: '#000',
        textFontSize: theme
          ? convertRemToPx(parseFloat(theme.fontSizes[2]))
          : undefined,
        tied: true,
      },
    },
  });

  const button = Button.item({
    ...props,
    features: {
      ...features,
      button: {
        ...features?.button,
        buttonPadding: '7px 16px 7px 16px',
        containerPadding: '24px 0px 0px 0px',
        hidden: false,
        horizontalAlign: 'left',
        mode: BUTTON_MODE_OPTIONS.NETWORK,
        tied: true,
        variant: BUTTON_VARIANT_OPTIONS.PRIMARY,
      },
    },
  });

  return [
    createNewItem(otherProps.image),
    createNewItem({
      ...headline,
      attributes: {
        ...headline.attributes,
        ...headlineAttributesToApply,
      },
    }),
    createNewItem({
      ...subline,
      attributes: {
        ...subline.attributes,
        ...sublineAttributesToApply,
      },
    }),
    createNewItem({
      ...button,
      attributes: {
        ...button.attributes,
        ...buttonAttributesToApply,
      },
    }),
  ];
};
